var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.46698,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DA293E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.769 10.1479C6.655 10.1479 6.541 10.1059 6.451 10.0159C6.277 9.84189 6.277 9.55389 6.451 9.37989L9.847 5.98389C10.021 5.80989 10.309 5.80989 10.483 5.98389C10.657 6.15789 10.657 6.44589 10.483 6.61989L7.087 10.0159C7.003 10.1059 6.883 10.1479 6.769 10.1479Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.165 10.1479C10.051 10.1479 9.937 10.1059 9.847 10.0159L6.451 6.61989C6.277 6.44589 6.277 6.15789 6.451 5.98389C6.625 5.80989 6.913 5.80989 7.087 5.98389L10.483 9.37989C10.657 9.55389 10.657 9.84189 10.483 10.0159C10.393 10.1059 10.279 10.1479 10.165 10.1479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossSaving);
export default __webpack_public_path__ + "static/media/IconCrossSaving.00b7f94dfb59f8a6ef1f9914aa8fe9e0.svg";
export { ForwardRef as ReactComponent };